import React, { useEffect } from 'react'

import { Text, Main } from '../../../components'
import { useCreateOrganization } from '../../../hooks/useCreateOrganization'
import { FormattedMessage, useIntl } from 'react-intl'

type BaseCreatingProps = {
  className?: string
  text?: string
}
export function BaseCreating({ text }: BaseCreatingProps) {
  return (
    <Main.Container style={{ textAlign: 'center' }}>
      <Main.Title>
        <FormattedMessage
          id="boarding.createOrganization.creating.title"
          defaultMessage="You're all set {spark}"
          values={{
            spark: (
              // eslint-disable-next-line formatjs/no-literal-string-in-jsx
              <span role="img" aria-label="spark">
                ✨
              </span>
            ),
          }}
        />
      </Main.Title>

      <Text.Corpus style={{ lineHeight: '1.8em' }}>
        {text}
        {text && <br />}
        <FormattedMessage
          id="boarding.createOrganization.creating.description"
          defaultMessage="You will be redirected in a few seconds."
          values={{}}
        />
      </Text.Corpus>
    </Main.Container>
  )
}

export function Creating({
  loginOrigin,
}: {
  superEnabled?: boolean
  loginOrigin?: string
}) {
  const intl = useIntl()
  const [createOrganization] = useCreateOrganization({ loginOrigin })
  useEffect(() => {
    createOrganization()
  }, [createOrganization])
  return (
    <BaseCreating
      text={intl.formatMessage({
        id: 'boarding.createOrganization.creating.text',
        defaultMessage: 'Creating your team...',
      })}
    />
  )
}
